<template>
    <el-row>
        <template v-if="isAccountAdmin">
            <el-col :span="4" :xs="24" class="text-right mt-3 mt-sm-0">
                <Button v-if="isRoleCreate" class="mb-3" type="primary" @click="onShowCreateRecord">
                    <i class="el-icon-plus mr-2"></i>
                    {{ $t('recordForm.createRecord') }}
                </Button>
                <div class="mb-3">
                    <Button v-if="isRoleUpdate" type="primary" @click="onUpdateMultipleData">
                        <i class="el-icon-edit-outline mr-2"></i>
                        {{ $t('recordForm.updateMultipleRecord') }}
                    </Button>
                </div>
                <div class="mb-3">
                    <Button type="primary" @click="onOpenDialog">
                        <i class="el-icon-chat-dot-square mr-2"></i>
                        {{ $t('recordForm.updateNotes') }}
                    </Button>
                </div>
            </el-col>
            <el-dialog :visible.sync="dialogVisible" class="dialog-custom dialog-custom-large" :before-close="onCancelDialog">
                <template slot="title">
                    <h5 class="modal-title">{{ $t('recordForm.updateNotes') }}</h5>
                </template>
                <slot name="content">
                    <div class="px-0 px-sm-3">
                        <InputField classes="mb-2 mb-sm-3" :label-text="$t('recordForm.note')" :span-label="2" :span-input="22">
                            <vue-editor v-model="notes" class=""></vue-editor>
                        </InputField>
                    </div>
                </slot>
                <div slot="footer" class="dialog-footer">
                    <div class="text-right py-2">
                        <Button type="warning" @click="onCancelDialog" classes="mr-2 btn-sm">
                            {{ $t('button.cancel') }}
                        </Button>
                        <Button type="primary" :disabled="isLoading" v-loading="isLoading" @click="updateNotes" classes="btn-sm">
                            {{ $t('recordForm.addNotes') }}
                        </Button>
                    </div>
                </div>
            </el-dialog>
        </template>
        <template v-else>
            <el-col :xs="24" class="button_handle">
                <Button class="item_btn mr-2" type="primary" v-if="notes && notes.replace(/<[^>]*>/g, '').trim() !== ''" @click="onOpenDialog">
                    <i class="el-icon-chat-dot-square mr-2"></i>
                    {{ $t('recordForm.noteShare') }}
                </Button>
                <Button v-if="isRoleCreate" class="mr-2 item_btn" type="primary" @click="onShowCreateRecord">
                    <i class="el-icon-plus mr-2"></i>
                    {{ $t('recordForm.createRecord') }}
                </Button>
                <div v-if="isRoleUpdate" class="mr-2 item_btn">
                    <Button type="primary" @click="onUpdateMultipleData">
                        <i class="el-icon-edit-outline mr-2"></i>
                        {{ $t('recordForm.updateMultipleRecord') }}
                    </Button>
                </div>
                <div v-if="isRoleExport" class="mr-2 item_btn">
                    <Button type="primary" class="mr-2" @click="onExportRecord">
                        <i class="el-icon-edit-outline mr-2"></i>
                        {{ $t('recordForm.exportRecord') }}
                    </Button>
                    <el-select v-model="typeExport" style="width: 75px">
                        <el-option v-for="value in listTypeExport" :key="value.type" :label="value.label" :value="value.type"></el-option>
                    </el-select>
                </div>
                <Button class="item_btn mr-2" type="primary" @click="onShowBoxFilter">
                    <i class="el-icon-orange mr-2"></i>
                    {{ $t('share.showBoxFilter') }}
                </Button>
            </el-col>
            <el-dialog :visible.sync="dialogVisible" class="dialog-custom dialog-custom-large">
                <template slot="title">
                    <h5 class="modal-title">{{ $t('recordForm.detailNoteShare') }}</h5>
                </template>
                <slot name="content">
                    <div class="vue-editor-render-custom">
                        <vue-editor v-model="notes" :editorOptions="{ readOnly: true }"></vue-editor>
                    </div>
                </slot>
                <div slot="footer" class="dialog-footer">
                    <div class="text-right py-2">
                        <Button type="warning" @click="dialogVisible = false" classes="mr-2 btn-sm">
                            {{ $t('button.cancel') }}
                        </Button>
                    </div>
                </div>
            </el-dialog>
        </template>
    </el-row>
</template>
<script>
import Button from '@/components/partials/Button.vue';
import InputField from '@/components/partials/InputField.vue';
import InputText from '@/components/partials/customs/InputText.vue';
import { VueEditor } from 'vue2-editor';

export default {
    name: 'input-handle',
    props: {
        isAccountAdmin: { type: Boolean, required: true, default: false },
        roleUser: { type: Array, required: true, default: ['detail', '', '', ''] },
        queryFilterKintone: { required: true, default: null },
        listFieldsKeys: { required: true, default: [] },
        dataShare: { required: false, default: {} }
    },
    components: {
        InputText,
        InputField,
        Button,
        VueEditor
    },
    data() {
        return {
            isLoading: false,
            dialogVisible: false,
            typeExport: 'csv',
            listTypeExport: [
                { type: 'csv', label: 'CSV' },
                { type: 'xlsx', label: 'XLSX' }
            ],
            notes: this.dataShare?.note ?? ''
        };
    },
    computed: {
        isRoleCreate() {
            return this.roleUser.includes('create');
        },

        isRoleUpdate() {
            return this.roleUser.includes('update');
        },

        isRoleExport() {
            return this.roleUser.includes('export');
        }
    },
    watch: {
        dataShare: {
            deep: true,
            handler: function () {
                this.notes = this.dataShare?.note ?? '';
            }
        }
    },
    methods: {
        onShowCreateRecord() {
            let queryId = this.$route.query.id ?? '';
            let dataLinkId = this.$route.query.idDataLink ?? '';
            this.$router.push({
                name: this.isAccountAdmin ? (this.$router.currentRoute.name === 'dataLinkMultiDataView' ? 'dataLinkMultiDataViewCreate' : 'dataViewCreate') : 'dataViewCreateChildren',
                query: {
                    idShare: queryId,
                    idDataLink: dataLinkId,
                    link_name: this.$route.query.link_name ?? ''
                }
            });
        },
        onUpdateMultipleData() {
            this.$router.push({
                name: this.isAccountAdmin
                    ? this.$router.currentRoute.name === 'dataLinkMultiDataView'
                        ? 'dataLinkMultiDataViewEditMultiple'
                        : 'dataViewEditMultiple'
                    : 'dataViewEditMultipleChildren',
                query: {
                    id: this.$route.query.id ?? '',
                    idDataLink: this.$route.query.idDataLink ?? '',
                    link_name: this.$route.query.link_name ?? '',
                    query_list: this.queryFilterKintone
                }
            });
        },
        onShowBoxFilter() {
            this.$emit('show-box-filter');
        },
        onExportRecord() {
            if (this.isLoading) return;
            this.isLoading = true;
            let successCallback = () => {
                this.$store.commit('noticeSystem/SET_MESSAGE', {
                    isShowMessage: true,
                    type: 'success',
                    message: this.$t('exportRecord.createExportSuccess')
                });
                this.isLoading = false;
            };
            let errorCallback = () => {
                this.isLoading = false;
            };
            let payload = {
                successCallback,
                errorCallback,
                data: {
                    id: this.$route.query.id,
                    type: 'export',
                    data_filter: this.queryFilterKintone,
                    field_export: this.listFieldsKeys,
                    extension: this.typeExport
                }
            };
            this.$store.dispatch('exportDataShare/create', payload);
        },
        onOpenDialog() {
            this.dialogVisible = true;
        },
        onCancelDialog() {
            this.dialogVisible = false;
            this.$emit('reset-data-link');
        },
        updateNotes() {
            if (this.isLoading) return;
            this.isLoading = true;
            let successCallback = (response) => {
                if (response.status === 200) {
                    this.$store.commit('noticeSystem/SET_MESSAGE', {
                        isShowMessage: true,
                        type: 'success',
                        message: this.$t('share.msgCreateSuccess')
                    });
                }
                this.dialogVisible = false;
                this.$emit('reset-data-link');
                this.isLoading = false;
            };
            let errorCallback = () => {
                this.isLoading = false;
            };
            let dataPayload = {
                notes: this.notes
            };
            let payload = {
                successCallback,
                errorCallback,
                data: dataPayload,
                id: this.$route.query.id ?? ''
            };
            this.$store.dispatch('connect/updateNotes', payload);
        }
    }
};
</script>
